import LandingNewPage from 'apps/promo/components/LandingPage/LandingNewPage';
import { LANDING } from 'apps/promo/constants/EntryPoint';
import { LANDING_NEW_VIEW } from 'apps/promo/constants/ServerConstants';
import { FOOTER_TYPE_REQUEST_LANDING, FOOTER_TYPE_SEND_LANDING, FROM, FROM_TO, LANG_COUNTRY, TO } from 'apps/promo/routes/routeConstant';
import { modifyLandingPageStrapiApi } from 'apps/promo/routes/strapiApiModifiers';

const landing = [
    {
        path: [
            '/guatemala',
            '/request',
            '/request-money',
            '/ru/zaprosit-dengi',
            '/uk/zaprosyty-hroshi',
            '/de/geld-erbitten',
            '/cs/pozadat-o-penize',
            '/it/richiesta-di-denaro',
            '/pl/popros-o-pieniadze',
            '/fr/demande-de-l-argent',
            '/ro/solicita-bani',
            '/tr/para-istemek',
            '/es/solicitar-una-transferencia-de-dinero',
            '/zh/shoukuan',
            '/in/minta-uang',
            '/vi/yeu-cau-chuyen-tien',
            '/pt/pedir-dinheiro',
            `/request/${FROM}/${TO}`,
            `/${LANG_COUNTRY}/request`,
            `/${LANG_COUNTRY}/request-money/${FROM_TO}`,
            `/${LANG_COUNTRY}/zaprosit-dengi/${FROM_TO}`,
            `/${LANG_COUNTRY}/zaprosyty-hroshi/${FROM_TO}`,
            `/${LANG_COUNTRY}/geld-erbitten/${FROM_TO}`,
            `/${LANG_COUNTRY}/pozadat-o-penize/${FROM_TO}`,
            `/${LANG_COUNTRY}/richiesta-di-denaro/${FROM_TO}`,
            `/${LANG_COUNTRY}/popros-o-pieniadze/${FROM_TO}`,
            `/${LANG_COUNTRY}/demande-de-l-argent/${FROM_TO}`,
            `/${LANG_COUNTRY}/solicita-bani/${FROM_TO}`,
            `/${LANG_COUNTRY}/para-istemek/${FROM_TO}`,
            `/${LANG_COUNTRY}/solicitar-una-transferencia-de-dinero/${FROM_TO}`,
            `/${LANG_COUNTRY}/shoukuan/${FROM_TO}`,
            `/${LANG_COUNTRY}/minta-uang/${FROM_TO}`,
            `/${LANG_COUNTRY}/yeu-cau-chuyen-tien/${FROM_TO}`,
            `/${LANG_COUNTRY}/pedir-dinheiro/${FROM_TO}`,
        ],
        exact: true,
        component: LandingNewPage,
        view: LANDING_NEW_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            isRequest: true,
            entryPoint: LANDING,
            strapiApi: '/api/calculator/request',
            modifyStrapiApi: modifyLandingPageStrapiApi,
            strapiApiUseCache: true,
            strapiApiCacheQueryParams: ['sourceCurrency', 'targetCurrency', 'sourceCountry', 'targetCountry'],
            footerType: FOOTER_TYPE_REQUEST_LANDING,
            menuSection: 'personal',
            isNewLanding: true,
        },
    },
    {
        path: [
            '/',
            '/send',
            '/send-money',
            '/alipay',
            '/ru/otpravit-dengi',
            '/uk/vidpravyty-hroshi',
            '/de/sende-geld',
            '/cs/poslat-penize',
            '/it/inviare-soldi',
            '/pl/wyslij-pieniadze',
            '/fr/envoyer-de-l-argent',
            '/ro/trimite-bani',
            '/tr/para-gondermek',
            '/es/enviar-dinero',
            '/zh/huikuan',
            '/in/kirim-uang',
            '/vi/chuyen-tien',
            '/uz/send-money',
            '/tl/send-money',
            '/pt/enviar-dinheiro',
            `/send/${FROM}/${TO}`,
            `/${LANG_COUNTRY}/send-money/${FROM_TO}`,
            `/${LANG_COUNTRY}/otpravit-dengi/${FROM_TO}`,
            `/${LANG_COUNTRY}/vidpravyty-hroshi/${FROM_TO}`,
            `/${LANG_COUNTRY}/sende-geld/${FROM_TO}`,
            `/${LANG_COUNTRY}/poslat-penize/${FROM_TO}`,
            `/${LANG_COUNTRY}/inviare-soldi/${FROM_TO}`,
            `/${LANG_COUNTRY}/wyslij-pieniadze/${FROM_TO}`,
            `/${LANG_COUNTRY}/envoyer-de-l-argent/${FROM_TO}`,
            `/${LANG_COUNTRY}/trimite-bani/${FROM_TO}`,
            `/${LANG_COUNTRY}/para-gondermek/${FROM_TO}`,
            `/${LANG_COUNTRY}/enviar-dinero/${FROM_TO}`,
            `/${LANG_COUNTRY}/huikuan/${FROM_TO}`,
            `/${LANG_COUNTRY}/kirim-uang/${FROM_TO}`,
            `/${LANG_COUNTRY}/chuyen-tien/${FROM_TO}`,
            `/${LANG_COUNTRY}/enviar-dinheiro/${FROM_TO}`,
            `/${LANG_COUNTRY}/send`,
            `/${LANG_COUNTRY}`,
        ],
        exact: true,
        component: LandingNewPage,
        view: LANDING_NEW_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            isRequest: false,
            entryPoint: LANDING,
            footerType: FOOTER_TYPE_SEND_LANDING,
            strapiApi: '/api/calculator/send',
            modifyStrapiApi: modifyLandingPageStrapiApi,
            strapiApiUseCache: true,
            strapiApiCacheQueryParams: ['sourceCurrency', 'targetCurrency', 'sourceCountry', 'targetCountry'],
            menuSection: 'personal',
            isNewLanding: true,
        },
    },
];

export default landing;
